import type { Security } from '@talos/kyoko';
import { OptionType } from './styles';

interface OptionTitleProps {
  security: Security;
}
export const OptionTitle = ({ security }: OptionTitleProps) => {
  const strikePrice = security.StrikePrice && security.StrikePrice !== '0' ? security.StrikePrice : '';

  return (
    <>
      <span>{strikePrice}</span> <OptionType type={security.OptionType}>{security.OptionType}</OptionType>
    </>
  );
};
